import { render, staticRenderFns } from "./AirportDetails.vue?vue&type=template&id=1986f85f&scoped=true&"
import script from "./AirportDetails.vue?vue&type=script&lang=js&"
export * from "./AirportDetails.vue?vue&type=script&lang=js&"
import style0 from "./AirportDetails.vue?vue&type=style&index=0&id=1986f85f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986f85f",
  null
  
)

export default component.exports